"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteMapsAdminApp = void 0;
var React = require("react");
var EditSiteMaps_1 = require("./EditSiteMaps");
var EditSiteInfo_1 = require("./EditSiteInfo");
var SiteInfoService_1 = require("../../../services/SiteInfoService");
var SiteMapService_1 = require("../../../services/SiteMapService");
var CurrentSelection_1 = require("../../../services/CurrentSelection");
var EditSiteMapInfo_1 = require("./EditSiteMapInfo");
var SiteLocationService_1 = require("../../../services/SiteLocationService");
var useNavPills_1 = require("../../lib/useNavPills");
var generic_1 = require("../../generic");
var EditMapLocations_1 = require("./EditMapLocations");
var SiteMapLayerService_1 = require("../../../services/SiteMapLayerService");
var EditSiteMapLayerInfo_1 = require("./EditSiteMapLayerInfo");
var side_bar_pills = [
    { id: 1, text: gettext("Site"), icon: generic_1.Icons.building },
    { id: 2, text: gettext("Map"), icon: generic_1.Icons.map_with_locations },
];
var SiteMapsAdminApp = function (_a) {
    var project_id = _a.project_id;
    var _b = __read((0, SiteInfoService_1.useSiteInfoService)(project_id), 2), site_info = _b[0], siteInfoService = _b[1];
    var site_id = site_info === null || site_info === void 0 ? void 0 : site_info.id;
    var _c = __read((0, SiteMapService_1.useSiteMapService)(project_id), 2), map_info = _c[0], siteMapsService = _c[1];
    var _d = __read((0, CurrentSelection_1.useCurrentSelection)(undefined, map_info), 2), getCurrentMap = _d[0], setCurrentMap = _d[1];
    var current_map = getCurrentMap();
    var _e = __read((0, SiteMapLayerService_1.useSiteMapLayerService)(project_id), 2), layer_info = _e[0], siteLayerSvc = _e[1];
    var _f = __read((0, SiteLocationService_1.useSiteLocationService)(project_id, current_map === null || current_map === void 0 ? void 0 : current_map.id), 2), site_location_info = _f[0], siteLocationService = _f[1];
    var _g = __read((0, CurrentSelection_1.useCurrentSelection)(undefined, site_location_info), 2), getCurrentLocation = _g[0], setCurrentLocation = _g[1];
    var current_location = getCurrentLocation();
    var _h = __read((0, useNavPills_1.useNavPills)("admin-site-pills", side_bar_pills), 2), active_pill = _h[0], NavPills = _h[1];
    React.useEffect(function () {
        siteInfoService.list();
        siteMapsService.list();
    }, [project_id]);
    React.useEffect(function () {
        if (map_info.length > 0 && current_map == undefined) {
            setCurrentMap(map_info[0].id);
        }
    }, [map_info, current_map]);
    React.useEffect(function () {
        if (current_map)
            siteLayerSvc.list();
    }, [project_id, current_map]);
    React.useEffect(function () {
        if (current_map)
            siteLocationService.list();
    }, [project_id, current_map]);
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-9" },
                React.createElement(EditSiteMaps_1.EditSiteMaps, { site_maps_info: map_info, current_map: current_map, layer_info: layer_info, setCurrentMap: setCurrentMap, location_info: site_location_info, locationService: siteLocationService, setCurrentLocation: setCurrentLocation })),
            React.createElement("div", { className: "col-3", id: "edit_project_manage_site_map" },
                React.createElement(NavPills, { row_class: "row mb-3", a_class: "gamification-admin-site-pills" }),
                active_pill == 1 && (React.createElement(EditSiteInfo_1.EditSiteInfo, { site_info: site_info, siteInfoSvc: siteInfoService, allow_add: true })),
                active_pill == 2 && site_id && (React.createElement(EditSiteMapInfo_1.EditSiteMapInfo, { site_id: site_id, current_map: current_map, siteMapsSvc: siteMapsService })),
                active_pill == 3 && current_map && site_id && (React.createElement(EditSiteMapLayerInfo_1.EditSiteMapLayerInfo, { site_id: site_id, layer_data: layer_info, layerSvc: siteLayerSvc })),
                active_pill == 4 && current_map && site_id && (React.createElement(EditMapLocations_1.EditMapLocations, { site_id: site_id, map_id: current_map.id, layer_data: layer_info, allow_layer: true, location: current_location, changeLocation: setCurrentLocation, siteLocationService: siteLocationService }))))));
};
exports.SiteMapsAdminApp = SiteMapsAdminApp;
